import { useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FeedSection from "./components/FeedSection";
import ThreadSection from "./components/ThreadSection";
import ForumSection from "./components/ForumSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import { faqs } from "@/mocks/gua";

const seoJson = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "大瓜网",
      url: "https://tyaxxf.cn/",
      inLanguage: "zh-CN",
      description:
        "大瓜网评论区热议、围观现场、吃瓜群众观点实时汇聚。热帖精选、话题互动，看瓜也看人，各路看法都在这里碰撞。",
      potentialAction: {
        "@type": "SearchAction",
        target: { "@type": "EntryPoint", urlTemplate: "https://tyaxxf.cn/?q={search_term_string}" },
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export default function Home() {
  const [query, setQuery] = useState("");

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(seoJson) }}
      />
      <Header />
      <main>
        <Hero onSearch={setQuery} />
        <FeedSection query={query} />
        <ThreadSection />
        <ForumSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}